"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceRange = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** PriceRange */
var PriceRange =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PriceRange, _React$Component);

  function PriceRange() {
    _classCallCheck(this, PriceRange);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceRange).apply(this, arguments));
  }

  _createClass(PriceRange, [{
    key: "formatter",
    value: function formatter(min, max, maxIndicator) {
      var formatOptions = {
        style: "currency",
        currency: this.props.currency,
        minimumFractionDigits: 0
      };
      var minPrice = min.toLocaleString("en-US", formatOptions);
      var maxPrice = max.toLocaleString("en-US", formatOptions);
      return "".concat(minPrice, " - ").concat(maxPrice).concat(maxIndicator);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_.LabeledRange, _extends({
        formatter: this.formatter.bind(this),
        label: this.props.currency
      }, this.props));
    }
  }]);

  return PriceRange;
}(_react.default.Component);

exports.PriceRange = PriceRange;

_defineProperty(PriceRange, "defaultProps", {
  currency: "USD",
  disabled: false
});

PriceRange.displayName = "PriceRange";
//# sourceMappingURL=PriceRange.js.map